"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CountryCode;
(function (CountryCode) {
    CountryCode["AT"] = "AT";
    CountryCode["BE"] = "BE";
    CountryCode["CH"] = "CH";
    CountryCode["DE"] = "DE";
    CountryCode["IT"] = "IT";
    CountryCode["LU"] = "LU";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));
//# sourceMappingURL=CountryCode.js.map